import { render, staticRenderFns } from "./SellingPointDescTable.vue?vue&type=template&id=692e6d7c&scoped=true&"
import script from "./SellingPointDescTable.vue?vue&type=script&lang=js&"
export * from "./SellingPointDescTable.vue?vue&type=script&lang=js&"
import style0 from "./SellingPointDescTable.vue?vue&type=style&index=0&id=692e6d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692e6d7c",
  null
  
)

export default component.exports